import React, { useState, useEffect, useRef } from "react";
import CardLayout from "../../../components/utils/CardLayout";
import SearchBar from "../../../components/utils/SearchBar";
import SideButtons from "../../../components/utils/SideButtons";
import Table from "../../../components/utils/Table";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import EyeFill from "remixicon-react/EyeFillIcon";
import AddPortinInventory from "./AddSimPinInventory";
import InventoryViewDetails from "./InventoryViewDetails";
import Alert from "../../../components/utils/Alert";
import DatePicker from "react-datepicker";
import Calendar2LineIcon from "remixicon-react/Calendar2LineIcon";
import moment from "moment";
import { useForm } from "react-hook-form";
import Button from "../../../components/utils/Button";
import SimPinActions from "../../../redux/SIMPINInventory/actions";

const {
  getSimPinInventoryList,
  resetSimPinInventoryMessage,
  getSimPinInventoryViewDetails,
} = SimPinActions;

const SimPinInventory = () => {
  const dispatch = useDispatch();
  const [filterText, setFilterText] = useState("");
  const [activeForm, setActiveForm] = useState("list");
  const [selectedInventoryId, setSelectedInventoryId] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertText, setAlertText] = useState("");

  const {
    addSimPinInventoryMessage,
    addSimPinInventoryError,
    getSimPinInventoryResult,
    getSimPinInventoryLoading,
  } = useSelector((state) => state.simPinInventory);

  const datePickerRef = useRef(null);
  const datePickerRef2 = useRef(null);
  const [toDate, setToDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(
    new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
  );
  const [searchData, setSearchData] = useState({
    fromDate: moment(fromDate).format("YYYY-MM-DD"),
    toDate: moment(toDate).format("YYYY-MM-DD"),
  });
  const {
    register: registerFilter,
    handleSubmit: handleSubmit,
    formState: { errors: filterError },
  } = useForm({ defaultValues: searchData });

  useEffect(() => {
    if (
      addSimPinInventoryMessage !== null &&
      addSimPinInventoryMessage !== undefined
    ) {
      displayAlert(addSimPinInventoryMessage, "alert-success");
    }
    if (
      addSimPinInventoryError !== null &&
      addSimPinInventoryError !== undefined
    ) {
      displayAlert(addSimPinInventoryError, "alert-danger");
    }
  }, [addSimPinInventoryMessage, addSimPinInventoryError]);

  const displayAlert = (text, type) => {
    setAlertText(text);
    setAlertType(type);
    setShowAlert(true);
  };

  const alertCancel = () => {
    setShowAlert(false);
    setAlertText("");
    setAlertType("");
  };
  useEffect(() => {
    dispatch(getSimPinInventoryList(searchData));
  }, []);

  const columns = [
    { displayName: "#", key: "key" },
    { displayName: "PURCHASE NUMBER", key: "purchaseNumber" },
    { displayName: "INVOICE NUMBER", key: "invoiceNumber" },
    { displayName: "NETWORK", key: "networkName" },
    { displayName: "PIN PRICE", key: "pinPrice" },
    { displayName: "SIM PIN COUNT", key: "simPinCount" },
    { displayName: "PURCHASE DATE", key: "purchaseDate" },
    { displayName: "PURCHASED BY(USER)", key: "purchasedBy" },
    { displayName: "ACTION", key: "action" },
  ];

  const handleFilterChange = (value) => {
    setFilterText(value);
  };

  const handleAddInventory = () => {
    dispatch(resetSimPinInventoryMessage());
    alertCancel();
    setActiveForm("add");
  };

  const handleShowInventoryDetails = (ID) => {
    setSelectedInventoryId(ID);
    setActiveForm("view");
    dispatch(getSimPinInventoryViewDetails(ID));
  };

  const openDatePicker = () => {
    datePickerRef.current.setOpen(true);
  };
  const openDatePicker2 = () => {
    datePickerRef2.current.setOpen(true);
  };

  const onSubmit = (data) => {
    const newData = {
      ...data,
      toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
      fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
    };
    dispatch(getSimPinInventoryList(newData));
  };

  const filteredItems = Array.isArray(getSimPinInventoryResult)
    ? getSimPinInventoryResult.filter((item) =>
        Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(filterText.toLowerCase()),
        ),
      )
    : [];

  const dataSource = filteredItems.map((item, key) => ({
    key: key + 1,
    purchaseNumber: item.PurchaseNumber,
    invoiceNumber: item.InvoiceNumber,
    networkName: item.NetworkName,
    purchasedBy: item.PurchaseName,
    purchaseDate: moment(item.PurchaseDtTm).format("YYYY-MM-DD"),
    pinPrice: `$${item.PINPrice.toFixed(2)}`,
    simPinCount: item.TotalCount,
    action: (
      <Link to="#" onClick={() => handleShowInventoryDetails(item.ID)}>
        <span data-toggle="tooltip" data-placement="top" title="View">
          <EyeFill size="1.2em" style={{ color: "#294c28eb" }} />
        </span>
      </Link>
    ),
  }));

  const renderForm = () => {
    switch (activeForm) {
      case "add":
        return (
          <AddPortinInventory
            back={() => setActiveForm("list")}
            searchData={searchData}
          />
        );
      case "view":
        return (
          <InventoryViewDetails
            back={() => setActiveForm("list")}
            id={selectedInventoryId}
          />
        );
      default:
        return (
          <>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-row">
                <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                  <label>From Date</label>
                  <Calendar2LineIcon
                    onClick={openDatePicker}
                    size={"1.5rem"}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "36px",
                      right: "12px",
                      zIndex: 1,
                    }}
                  />
                  <DatePicker
                    ref={datePickerRef}
                    selected={fromDate}
                    className="form-control"
                    onChange={(date) => setFromDate(date)}
                    dateFormat="yyyy-MM-dd"
                    name="fromDate"
                    showMonthDropdown
                    showYearDropdown
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                    value={fromDate}
                  />
                </div>

                <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                  <label>To Date</label>
                  <Calendar2LineIcon
                    onClick={openDatePicker2}
                    size={"1.5rem"}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "36px",
                      right: "12px",
                      zIndex: 1,
                    }}
                  />
                  <DatePicker
                    ref={datePickerRef2}
                    selected={toDate}
                    className="form-control center"
                    onChange={(date) => setToDate(date)}
                    dateFormat="yyyy-MM-dd"
                    name="todate"
                    showMonthDropdown
                    showYearDropdown
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                    value={toDate}
                  />
                </div>

                <div className="col-lg-2 mb-2 col-md-4">
                  <div className="mb-2 mt-lg-4 mt-md-4">
                    <Button
                      title="Search"
                      style="minWidth:80px"
                      buttonClass={` btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`}
                      buttonType="submit"
                      loading={getSimPinInventoryLoading}
                    />
                  </div>
                </div>
              </div>
            </form>
            <hr />
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <SearchBar
                  onFilter={handleFilterChange}
                  filterText={filterText}
                />
              </div>
              <div className="col-lg-6 col-md-6 text-right">
                <SideButtons
                  title="Add SIM PIN"
                  buttonStyle="primary"
                  onClick={handleAddInventory}
                />
              </div>
            </div>

            <Table
              columns={columns}
              loading={getSimPinInventoryLoading}
              data={dataSource}
              pagination={true}
            />
          </>
        );
    }
  };
  return (
    <>
      {/* <CardLayout title="SIM PIN Inventory" cardClass="portin-card-class">
        {" "}
        {portinCountDataLoading ? (
          <div className="inventory-loader-page">
            <span
              className="spinner-border spinner-border-lg"
              role="status"
            ></span>
          </div>
        ) : (
          <div className="row d-flex justify-content-between text-center">
            <div className="col">
              <h6
                className="text-muted mb-0 fw-semibold"
                style={{ fontSize: "14px", textTransform: "uppercase" }}
              >
                Total
              </h6>
              <h5
                className="text-primary mb-0 fw-bold shadow-sm"
                style={{
                  fontSize: "18px",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  backgroundColor: "#E3F2FD",
                }}
              >
                {formatDigits(portinCountData.TotalInventory ?? 0)}
              </h5>
            </div>

            <div className="col">
              <h6
                className="text-muted mb-0 fw-semibold"
                style={{ fontSize: "14px", textTransform: "uppercase" }}
              >
                Used
              </h6>
              <h5
                className="text-danger mb-0 fw-bold shadow-sm"
                style={{
                  fontSize: "18px",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  backgroundColor: "#FFEBEE",
                }}
              >
                {formatDigits(portinCountData.UsedInventory ?? 0)}
              </h5>
            </div>

            <div className="col">
              <h6
                className="text-muted mb-0 fw-semibold"
                style={{ fontSize: "14px", textTransform: "uppercase" }}
              >
                Processing
              </h6>
              <h5
                className="text-warning mb-0 fw-bold shadow-sm"
                style={{
                  fontSize: "18px",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  backgroundColor: "rgb(252 246 227)",
                }}
              >
                {formatDigits(portinCountData.ProcessingInventory ?? 0)}
              </h5>
            </div>

            <div className="col">
              <h6
                className="text-muted mb-0 fw-semibold"
                style={{ fontSize: "14px", textTransform: "uppercase" }}
              >
                Available
              </h6>
              <h5
                className="text-success mb-0 fw-bold shadow-sm"
                style={{
                  fontSize: "18px",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  backgroundColor: "#E8F5E9",
                }}
              >
                {formatDigits(portinCountData.FreeInventory ?? 0)}
              </h5>
            </div>
          </div>
        )}
      </CardLayout> */}

      <CardLayout
        title={
          activeForm === "add"
            ? "SIM PIN Inventory"
            : activeForm === "view"
              ? "SIM PIN Inventory Details"
              : "SIM PIN Inventory"
        }
        cardClass="portin-card-class-table"
      >
        {showAlert && (
          <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
        )}
        {renderForm()}
      </CardLayout>
    </>
  );
};

export default SimPinInventory;
